/** Detect sample type abbreviations like 1st / 2nd / 3rd */
export const isFirstSampleAbbr = (abbr = "") => {
  const value = String(abbr || "")
    .trim()
    .toLowerCase();
  return (
    value === "1st" ||
    value === "1ª" ||
    value === "1a" ||
    value === "first" ||
    value === "1"
  );
};

export const shouldCopyFromFirstSample = (abbr = "") => {
  const value = String(abbr || "").trim();
  if (!value) return false;
  return !isFirstSampleAbbr(value);
};

export const findFirstSampleForProduct = (samples = [], tiposMuestra = []) => {
  if (!Array.isArray(samples) || samples.length === 0) return null;

  const firstTipoIds = new Set(
    (tiposMuestra || [])
      .filter((tipo) => isFirstSampleAbbr(tipo?.ABREVIATURA))
      .map((tipo) => Number(tipo.ID_TIPO)),
  );

  const byTipo = samples.find((sample) =>
    firstTipoIds.has(Number(sample.ID_TIPO_MUESTRA)),
  );
  if (byTipo) return byTipo;

  const byName = samples.find((sample) =>
    /-1st(?:\b|$)/i.test(String(sample.MUESTRA || "")),
  );
  if (byName) return byName;

  return [...samples].sort(
    (a, b) => Number(a.ID_MUESTRA) - Number(b.ID_MUESTRA),
  )[0];
};

/** Fields safe/useful to copy when creating 2nd/3rd from 1st */
export const buildMuestraFieldsFromFirst = (first = {}) => ({
  NombreCliente: first.NombreCliente || first.NOMBRE_CLIENTE || "",
  ID_Marca: first.ID_Marca ?? "",
  PROVEEDOR: first.PROVEEDOR || "",
  ID_RESPONSABLE_SUPPLIER: first.ID_RESPONSABLE_SUPPLIER ?? null,
  ID_TALLA_BASE: first.ID_TALLA_BASE ?? "",
  ID_COLOR_BASE: first.ID_COLOR_BASE ?? "",
  PRIORIDAD: first.PRIORIDAD || null,
  DEVELOPMENT: first.DEVELOPMENT || null,
  CALIDAD_NOMBRE: first.CALIDAD_NOMBRE || "",
  CALIDAD_REFERENCIA: first.CALIDAD_REFERENCIA || "",
  CALIDAD_MATERIAL: first.CALIDAD_MATERIAL || "",
  CALIDAD_ESTADO: first.CALIDAD_ESTADO ?? null,
  PRINT_NOMBRE: first.PRINT_NOMBRE || "",
  PRINT_ESTADO: first.PRINT_ESTADO ?? null,
  NOTAS: first.NOTAS || "",
  FECHA_PETICION: first.FECHA_PETICION || null,
  FECHA_PREVISTA: first.FECHA_PREVISTA || null,
  FECHA_GET_SUPPLIER: first.FECHA_GET_SUPPLIER || null,
  FECHA_PREVISTA_FABRICA: first.FECHA_PREVISTA_FABRICA || null,
  // Keep workflow dates empty for the new sample
  FECHA_ENVIO: null,
  FECHA_RECEPCION: null,
});

export const buildEscandallosFromFirst = (escandallos = []) =>
  (Array.isArray(escandallos) ? escandallos : [])
    .filter((esc) => esc?.ESCANDALLO_GRUPOS && esc?.ESCANDALLO_SUBGRUPO)
    .map((esc) => ({
      PROVEEDOR_ESCANDALLO: esc.PROVEEDOR_ESCANDALLO || esc.Proveedor || "",
      UN: esc.UN || esc.Un || "",
      COSTE: esc.COSTE || esc.Coste || "",
      ESCANDALLO_GRUPOS: esc.ESCANDALLO_GRUPOS || "",
      ESCANDALLO_SUBGRUPO: esc.ESCANDALLO_SUBGRUPO || "",
      SUBGRUPOS_LIST: esc.SUBGRUPOS_LIST || [],
    }));
